<template>
  <div class="location-radius-selector">
    <div
      class="ais-RefinementList search-filter-filter-location-list search-filter-filter-select-list"
      role="radiogroup"
    >
      <button
        v-for="radius in radiusOptions"
        :key="radius"
        role="radio"
        :aria-checked="selectedRadius === radius"
        :aria-label="radius / 1000 + ' kilometers'"
        :class="[
          'select-button',
          'loc-radius-button',
          { '-active': selectedRadius === radius },
        ]"
        @click="selectRadius(radius)"
      >
        {{ radius / 1000 }}km
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocationRadiusSelector",
  props: {
    radiusOptions: {
      type: Array,
      default: () => [5000, 10000, 50000],
    },
    coordinates: {
      type: String,
      default: "",
    },
    initialRadius: {
      type: Number,
      default: 0,
    },
  },
  emits: ["radius-changed"],
  data() {
    return {
      selectedRadius: this.initialRadius,
    };
  },
  watch: {
    initialRadius(newValue) {
      this.selectedRadius = newValue;
    },
  },
  methods: {
    selectRadius(radius) {
      this.selectedRadius = radius;
      this.$emit("radius-changed", radius);
    },
    clearRadius() {
      this.selectedRadius = 0;
      this.$emit("radius-changed", 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.location-radius-selector {
  margin-top: 10px;

  .select-button {
    cursor: pointer;

    display: inline-block;
    text-align: center;

    margin-right: 8px;
    margin-bottom: 8px;
    padding: 6px 12px;

    background-color: transparent;
    border: 1px solid var(--search-filter-border-color);
    color: var(--search-filter-text-color);
    border-radius: 4px;

    transition: all 0.2s ease;

    &:hover {
      background-color: var(--search-filter-hover-color);
    }

    &.-active {
      background-color: var(--search-filter-overlay-button-active-bg-color);
      color: var(--search-filter-overlay-button-active-text-color);
      border-color: var(--search-filter-overlay-button-active-bg-color);
    }
  }
}
</style>
